import React from 'react';
import { Button } from './ui/button';

const CTASection = () => {
  return (
    <section className="relative py-24">
      {/* Background */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://images.pexels.com/photos/3769138/pexels-photo-3769138.jpeg?auto=compress&cs=tinysrgb&w=1920')`,
        }}
      />
      <div className="absolute inset-0 bg-[#1a3a5c]/85" />
      
      {/* Red Stripe */}
      <div className="absolute top-0 left-0 right-0 h-2 bg-[#c94a4a]"></div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-white text-3xl md:text-4xl font-bold mb-6 uppercase italic">
          Ready to Take the First Step Towards Your American Dream?
        </h2>
        <p className="text-gray-300 text-lg mb-8">
          Sign up for a free Seminar or one-on-one consultation with a Visa Expert and immigration attorney near you.
        </p>
        <Button
          onClick={() => document.getElementById('hero-form')?.scrollIntoView({ behavior: 'smooth' })}
          className="bg-[#c94a4a] hover:bg-[#b33d3d] text-white px-10 py-4 rounded font-medium text-lg"
        >
          Contact Us Now
        </Button>
      </div>
    </section>
  );
};

export default CTASection;
